import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {AlertService, SalesPhraseService} from '../_services';
import {FormArray, FormBuilder, FormControl, Validators} from '@angular/forms';
import {SalesPhrase} from '../_models';
import {NgxSmartModalService} from "ngx-smart-modal";
import {takeUntil} from "rxjs/operators";
import {UpsaleProductFieldsComponent} from "./upsale-product-fields.component";
import {ProductSubtextComponent} from '../product-subtext';

@Component({
  moduleId: module.id.toString(),
  templateUrl: './exchangeable-product-fields.component.html',
  selector: 'exchangeable-product-fields',
  styleUrls: ['./exchangeable-product.component.css']
})
export class ExchangeableProductFieldsComponent extends UpsaleProductFieldsComponent implements OnInit {
  salesPhraseOptions: any[] = [];
  styles = null;
  @Input('isRelated') isRelated = false;
  @ViewChild("exchangeableSubtext", { static: false }) productSubtexts: ProductSubtextComponent;
  constructor(
    protected router: Router,
    protected location: Location,
    protected alertService: AlertService,
    protected formBuilder: FormBuilder,
    protected modalService: NgxSmartModalService,
    private salesPhraseService: SalesPhraseService
  ) {
    super(router, location, alertService, formBuilder, modalService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.form.addControl('sales_phrase', new FormControl(null));
    this.form.addControl('retail_price', new FormControl(null, Validators.min(0)));
    this.form.addControl('subtext', new FormArray([]));

    if (this.isRelated) {
      this.form.addControl('portal_discount', new FormControl(0, [Validators.min(0), Validators.max(100)]));
      this.form.addControl('portal_add_on_discount', new FormControl(0, [Validators.min(0), Validators.max(100)]));
      this.form.addControl('marketplace_enable', new FormControl(true));
      this.form.addControl('portal_enable', new FormControl(true));

      if (this.exchangeableProduct) {
        this.form.patchValue(this.exchangeableProduct);
      }
    }

    this.salesPhraseService.list()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (salesPhrases: SalesPhrase[]) => {
          let phrases = [];

          salesPhrases.forEach((salesPhrase: SalesPhrase) => {
            phrases.push({value: salesPhrase.id, text: salesPhrase.text});
          });

          phrases.sort((a, b): number => {
            if (a.text < b.text) return -1;
            if (a.text > b.text) return 1;
            return 0;
          });

          this.salesPhraseOptions = phrases;
        },
        error => {
          this.handleError(error);
        }
      );
  }

  ngOnChanges() {
    super.ngOnChanges();
    if (this.exchangeableProduct && !this.styles) {
      this.styles = this.exchangeableProduct.styles || {};
    }
  }

  getSalesPhraseStyle(style: string) {
    return this.styles && style in this.styles ? this.styles[style] : null;
  }

  setSalesPhraseStyle(style: string, value: string) {
    this.styles[style] = value.trim();
  }

  onCreateSalesPhraseStart() {
    this.modalService.getModal('exchangeSalesPhraseDialog').open();
  }

  onCreateSalesPhraseDone(salesPhrase: SalesPhrase) {
    let phrases = this.salesPhraseOptions;

    phrases.push({value: salesPhrase.id, text: salesPhrase.text});
    phrases.sort((a, b): number => {
      if (a.text < b.text) return -1;
      if (a.text > b.text) return 1;
      return 0;
    });

    this.salesPhraseOptions = phrases;
    this.form.patchValue({sales_phrase: salesPhrase.id});
    this.modalService.getModal('exchangeSalesPhraseDialog').close();

    if (this.exchangeableProduct) {
      this.exchangeableProduct.sales_phrase = salesPhrase.id;
    }
  }

  protected resetForm(scrollToTop: boolean = false) {
    super.resetForm(scrollToTop);

    if (this.isRelated) {
      this.form.patchValue({marketplace_enable: true, portal_enable: true, portal_discount: 0, portal_add_on_discount: 0});
    }
  }

  getFormData() {
    const data = Object.assign({}, this.form.value, {
      styles: this.styles,
      subtext: this.productSubtexts.getFormData()
    });

    if (this.isRelated) {
      ['portal_discount', 'portal_add_on_discount'].forEach(field => {
        if (data[field] === '' || data[field] === null) {
          data[field] = 0;
        }
      });
    }

    return data;
  }

}
